import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static values = {
		name: String,
	};

	connect() {
		if (CSS.supports('animation-range: exit 10vh exit 100%')) return;

		this.onScroll = this.onScroll.bind(this);
		window.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onScroll);
		this.onScroll();
	}

	disconnect() {
		window.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onScroll);
	}

	onScroll() {
		const rect = this.element.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		let progress = 0;

		if (this.nameValue == 'lastSection') {
			const start = windowHeight * 0.9; // 10vh od spodku viewportu
			const end = 0;

			const range = start - end;
			progress = this.clamp((start - rect.bottom) / range, 0, 1);
		} else {
			if (this.element.offsetHeight > window.innerHeight) {
				progress = this.clamp(
					(window.scrollY + window.innerHeight - (this.element.offsetTop + this.element.offsetHeight)) / window.innerHeight,
					0,
					1,
				);
			} else {
				progress = this.clamp(window.scrollY / (this.element.offsetTop + this.element.offsetHeight), 0, 1); // topScrollPosition / bottomEl
			}
		}
		const translateY = (window.innerHeight / 2) * progress; // 0 → 50vh v px

		const brightness = 100 - 10 * progress; // 100% → 90%

		this.element.style.transform = `translateY(${translateY}px)`;
		this.element.style.filter = `brightness(${brightness}%)`;
	}

	clamp(value, min, max) {
		return Math.min(Math.max(value, min), max);
	}

	getTranslateY(element) {
		const style = window.getComputedStyle(element);
		const matrix = new DOMMatrixReadOnly(style.transform);
		return matrix.m42;
	}
}
